import React, { Component } from "react";
import PersonalGrade from "../personal/personalGrade.js";
import Salary from "./salary.js";
import Expenses from "./expenses";
import Borrow from "./borrow";
import EmptyInternal from "./emptyInternal";
class InternalList extends Component {
	render() {
		return (
			this.showDiffComponentByName()
		)
	}
	showDiffComponentByName() {
		const internalName = this.props.match.params.internalName;
		switch (internalName) {
			case "grade":
				return <PersonalGrade history={this.props.history} />
			case "salary":
				return <Salary history={this.props.history} />
			case "expenses":
				return <Expenses history={this.props.history} />
			case "borrow":
				return <Borrow history={this.props.history} />
			case "empty":
				return <EmptyInternal history={this.props.history} />
			default:
				return <EmptyInternal history={this.props.history} />;
		}
	}
}
export default InternalList